import { createReducer, on } from "@ngrx/store";
import { UploadedBill } from "../../../models/bill.model";
import { billActions } from "../bill.actions";

export interface BillUploadBackendState {
    uploadedBills: UploadedBill[] | null,
    state: 'pending' | 'loading' | 'loaded' | 'error'
}

export const initialState: BillUploadBackendState = {
    uploadedBills: null,
    state: 'pending'
}

export const billUploadBackendReducer = createReducer(
    initialState,
    on(billActions.uploadBillsBackend, (state) => ({
        ...state,
        uploadedBills: null,
        state: 'loading' as const
    })),
    on(billActions.uploadBillsBackendSuccess, (state, {payload}) => ({
        ...state,
        uploadedBills: payload,
        state: 'loaded' as const
    })),
    on(billActions.uploadBillsBackendFail, (state) => ({
        ...state,
        uploadedBills: null,
        state: 'error' as const
    })),
    on(billActions.clearUploadBillsBackend, (state) => ({
        ...state,
        uploadedBills: null,
        state: 'pending' as const
    }))
)